import dayjs from '../config/dayjs';
import { deepGet } from '../api/Utils';

export function getDateRange(data: any, path: Array<string>, startDate: any, endDate: any, format: string) {
  let filterStartDate = dayjs(startDate).format(format);
  let filterEndDate = dayjs(endDate).format(format);
  return data.filter((item: any) =>
    dayjs(dayjs(deepGet(item, [...path])).format(format)).isBetween(filterStartDate, filterEndDate, null, '[]')
  );
}

export function getDifference(startDate: string, endDate: string) {
  const start = dayjs.utc(startDate);
  const end = dayjs.utc(endDate);
  const diff = end.diff(start, 'month');
  if (diff >= 1) {
    return diff + ' months';
  }
  return end.diff(start, 'day') + ' days';
}
